import React from "react";

function Icon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="1062"
      height="1051.554"
      fillRule="nonzero"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit="10"
      clipRule="evenodd"
      version="1.1"
      viewBox="0 0 1062 1051.554"
      xmlSpace="preserve"
      className='clickable'
    >
      <g
        fill="rgba(0,0,0,0)"
        className='object-glow'
        stroke="#ff5c97"
        strokeLinecap="round"
        strokeLinejoin="round"
        transform="translate(-1558.5 -793.346)"
      >
        <path
          strokeWidth="5"
          d="M2471.7 914.9c.23.7.47 1.4.7 2.1-.23-.7-.47-1.4-.7-2.1-.23-.7-.47-1.4-.7-2.1.23.7.47 1.4.7 2.1zm25.9 41.3c1.17.7 2.33 1.4 3.5 2.1 2.33 1.4 3.5 3.033 3.5 4.9v2.8l-3.5-1.4c-2.33-.933-3.5-2.567-3.5-4.9v-3.5zm16.8 15.4c2.8 0 4.9.7 6.3 2.1 1.4 1.4 1.87 3.5 1.4 6.3-.47 2.8-1.4 4.433-2.8 4.9-1.4.467-3.5-.467-6.3-2.8-2.8-2.333-3.97-4.667-3.5-7 .47-2.333 2.1-3.5 4.9-3.5zm-769.3 154.7c-16.33 2.33-29.4 6.3-39.2 11.9-9.8 5.6-17.73 12.6-23.8 21s-10.5 16.1-13.3 23.1c-2.8 7-6.53 29.17-11.2 66.5-4.67 37.33-7.93 59.97-9.8 67.9-1.87 7.93-7.47 20.53-16.8 37.8-9.33 17.27-15.63 31.27-18.9 42-3.27 10.73-8.87 22.63-16.8 35.7-7.93 13.07-12.37 23.33-13.3 30.8-.93 7.47-.47 13.3 1.4 17.5 1.87 4.2 2.57 7.93 2.1 11.2-.47 3.27-1.87 6.07-4.2 8.4s-4.9 3.97-7.7 4.9c-2.8.93-5.6 3.27-8.4 7-2.8 3.73-4.2 6.53-4.2 8.4s1.87 4.43 5.6 7.7c3.73 3.27 5.83 7 6.3 11.2.47 4.2 1.87 7 4.2 8.4 2.33 1.4 2.8 10.03 1.4 25.9s-3.27 26.37-5.6 31.5c-2.33 5.13-3.5 9.1-3.5 11.9 0 2.8.93 5.13 2.8 7 1.87 1.87 3.27 4.43 4.2 7.7.93 3.27 1.4 7.23 1.4 11.9s-1.63 8.87-4.9 12.6c-3.27 3.73-5.37 7.93-6.3 12.6-.93 4.67-.7 9.33.7 14s3.27 8.63 5.6 11.9c2.33 3.27 3.73 12.37 4.2 27.3.47 14.93 1.63 27.53 3.5 37.8 1.87 10.27 4.43 18.67 7.7 25.2 3.27 6.53 9.1 14.23 17.5 23.1 8.4 8.87 16.8 14.93 25.2 18.2 8.4 3.27 18.9 5.13 31.5 5.6 12.6.47 22.87-.23 30.8-2.1a134.39 134.39 0 0023.1-7.7c7.47-3.27 16.8-8.87 28-16.8 11.2-7.93 23.33-18.67 36.4-32.2 13.07-13.53 24.97-28.47 35.7-44.8 10.73-16.33 19.13-31.73 25.2-46.2 6.07-14.47 10.27-23.33 12.6-26.6 1.17-1.63 2.33-3.27 3.5-4.9l7.7 11.9c5.13 7.93 10.03 19.37 14.7 34.3 4.67 14.93 7 24.73 7 29.4 0 4.67-.93 8.87-2.8 12.6-1.87 3.73-3.03 8.4-3.5 14-.47 5.6-1.63 9.57-3.5 11.9s-2.57 5.37-2.1 9.1c.47 3.73 1.63 6.53 3.5 8.4s5.13 3.73 9.8 5.6c4.67 1.87 9.8 3.03 15.4 3.5 5.6.47 11.43.47 17.5 0s11.43-1.63 16.1-3.5c4.67-1.87 17.73-3.27 39.2-4.2 10.73-.47 21.47-.93 32.2-1.4l-2.1 13.3c-1.4 8.87-1.87 15.17-1.4 18.9.47 3.73 2.57 6.77 6.3 9.1s11.2 4.43 22.4 6.3 24.27 3.03 39.2 3.5c14.93.47 27.53 2.1 37.8 4.9 10.27 2.8 22.87 4.2 37.8 4.2 14.93 0 28-1.17 39.2-3.5 11.2-2.33 17.27-4.2 18.2-5.6.93-1.4.93-4.43 0-9.1s-3.03-7.93-6.3-9.8c-3.27-1.87-7.23-2.8-11.9-2.8s-9.33-.93-14-2.8c-4.67-1.87-7.23-3.5-7.7-4.9-.47-1.4.23-3.03 2.1-4.9l2.8-2.8c-2.1-1.87-4.2-3.73-6.3-5.6-4.2-3.73-8.17-8.63-11.9-14.7-3.73-6.07-9.57-10.73-17.5-14-7.93-3.27-15.87-4.9-23.8-4.9-7.93 0-12.6-1.17-14-3.5-1.4-2.33-4.9-5.13-10.5-8.4-5.6-3.27-10.5-7.93-14.7-14-4.2-6.07-6.3-10.97-6.3-14.7 0-3.73-1.4-7.93-4.2-12.6-2.8-4.67-4.9-7-6.3-7-1.4 0-10.97-18.2-28.7-54.6-17.73-36.4-24.97-56.93-21.7-61.6 3.27-4.67 5.6-9.57 7-14.7 1.4-5.13 1.17-12.83-.7-23.1-.93-5.13-1.87-10.27-2.8-15.4h3.5c2.33 0 6.9-5.14 13.68-9.85 6.58-4.58 9.89-6.95 13.62-6.95 3.73 0-6.93-45.06-17.2-45.06-10.26 0-10.1 2.36-19.9 6.56-9.8 4.2-16.1 4.43-18.9.7-2.8-3.73-7-7.23-12.6-10.5-5.6-3.27-9.1-6.07-10.5-8.4-1.4-2.33-3.97-3.97-7.7-4.9-3.73-.93-10.73-5.37-21-13.3-10.27-7.93-20.77-14.93-31.5-21s-17.03-10.73-18.9-14c-1.87-3.27-3.97-5.13-6.3-5.6-2.33-.47-3.73-1.63-4.2-3.5-.47-1.87-2.57-3.97-6.3-6.3-3.73-2.33-7.23-5.83-10.5-10.5-3.27-4.67-8.87-10.27-16.8-16.8-7.93-6.53-15.4-11.67-22.4-15.4-7-3.73-10.97-7.23-11.9-10.5-.93-3.27 2.33-11.43 9.8-24.5 7.47-13.07 13.07-20.53 16.8-22.4 3.73-1.87 10.27-3.5 19.6-4.9 9.33-1.4 15.4-3.27 18.2-5.6 2.8-2.33 4.2-8.4 4.2-18.2 0-9.8-.7-15.17-2.1-16.1-1.4-.93-1.87-2.57-1.4-4.9.47-2.33 0-5.13-1.4-8.4-1.4-3.27-.7-6.53 2.1-9.8 2.8-3.27 3.73-5.83 2.8-7.7-.93-1.87-5.13-5.13-12.6-9.8-7.47-4.67-13.3-14-17.5-28-4.2-14-7.23-23.33-9.1-28-1.87-4.67-3.97-8.17-6.3-10.5-2.33-2.33-6.3-4.43-11.9-6.3-5.6-1.87-14.47-3.03-26.6-3.5-12.13-.47-26.37.47-42.7 2.8zm-175.7 395.5c-.47.7-.93 1.4-1.4 2.1-.47.7-.93 1.4-1.4 2.1.47-.7.93-1.4 1.4-2.1.47-.7.93-1.4 1.4-2.1zm745.5-718.2c-10.73 5.6-24.5 16.8-41.3 33.6-16.8 16.8-26.6 30.8-29.4 42-2.8 11.2-3.5 22.167-2.1 32.9 1.4 10.733 4.9 20.533 10.5 29.4 5.6 8.867 11.9 14.467 18.9 16.8 7 2.333 12.37 4.9 16.1 7.7 3.73 2.8 5.6 4.9 5.6 6.3 0 1.4-2.33 3.5-7 6.3s-9.33 7-14 12.6-11.43 28.93-20.3 70c-8.87 41.07-15.87 67.2-21 78.4-5.13 11.2-7.93 20.77-8.4 28.7-.47 7.93-2.57 12.83-6.3 14.7-3.73 1.87-5.13 6.77-4.2 14.7.93 7.93-1.17 14-6.3 18.2-5.13 4.2-8.4 9.1-9.8 14.7-1.4 5.6-3.97 11.2-7.7 16.8-3.73 5.6-6.3 12.37-7.7 20.3-1.4 7.93-3.97 12.83-7.7 14.7-3.73 1.87-6.53 4.9-8.4 9.1-1.87 4.2-7.47 8.63-16.8 13.3-9.33 4.67-15.87 10.5-19.6 17.5-3.73 7-5.6 14.47-5.6 22.4 0 7.93.7 14.23 2.1 18.9 1.4 4.67 3.97 9.8 7.7 15.4s7 9.1 9.8 10.5c2.8 1.4 6.3 8.17 10.5 20.3s9.57 21.47 16.1 28c6.53 6.53 12.83 11.67 18.9 15.4 6.07 3.73 9.8 5.13 11.2 4.2 1.4-.93 1.63-3.73.7-8.4-.93-4.67-2.57-7.93-4.9-9.8-2.33-1.87-4.67-5.6-7-11.2s-3.27-11.43-2.8-17.5c.23-3.03.47-6.07.7-9.1 2.57 3.5 5.13 7 7.7 10.5 5.13 7 10.03 10.27 14.7 9.8 4.67-.47 19.13 3.03 43.4 10.5 24.27 7.47 38.03 31.73 41.3 72.8 3.27 41.07 4.67 66.03 4.2 74.9-.47 8.87-1.4 14.23-2.8 16.1-1.4 1.87-2.1 4.2-2.1 7s.93 5.37 2.8 7.7c1.87 2.33 2.8 4.43 2.8 6.3s-2.33 13.3-7 34.3c-4.67 21-8.87 35.23-12.6 42.7-3.73 7.47-5.83 13.07-6.3 16.8-.47 3.73-3.5 10.73-9.1 21s-8.63 17.03-9.1 20.3c-.47 3.27-2.33 5.83-5.6 7.7-3.27 1.87-4.9 3.73-4.9 5.6 0 1.87-2.8 5.6-8.4 11.2-5.6 5.6-8.17 11.43-7.7 17.5.47 6.07 4.2 10.5 11.2 13.3 7 2.8 16.8 3.97 29.4 3.5 12.6-.47 24.27-2.57 35-6.3s18.2-7.7 22.4-11.9c4.2-4.2 8.17-11.67 11.9-22.4 3.73-10.73 9.8-22.87 18.2-36.4 8.4-13.53 12.83-23.33 13.3-29.4.47-6.07-2.8-16.57-9.8-31.5-7-14.93-10.73-24.73-11.2-29.4-.47-4.67-.47-9.8 0-15.4s3.03-9.8 7.7-12.6c4.67-2.8 7-8.87 7-18.2s2.1-22.17 6.3-38.5c4.2-16.33 7.7-35.93 10.5-58.8l4.2-34.3c1.63.47 3.27.93 4.9 1.4 3.27.93 10.5 1.17 21.7.7s22.17.23 32.9 2.1c10.73 1.87 18.43 3.5 23.1 4.9 4.67 1.4 7.93 3.27 9.8 5.6 1.87 2.33 6.77 5.37 14.7 9.1 7.93 3.73 13.53 5.37 16.8 4.9 3.27-.47 5.37 0 6.3 1.4.93 1.4 4.43 1.63 10.5.7 6.07-.93 13.07-.7 21 .7s18.43 5.83 31.5 13.3c13.07 7.47 21.93 11.2 26.6 11.2 4.67 0 8.63-1.63 11.9-4.9 3.27-3.27 2.33-9.8-2.8-19.6s-12.6-21.47-22.4-35c-9.8-13.53-21.23-25.9-34.3-37.1-13.07-11.2-19.6-17.5-19.6-18.9 0-1.4 5.83-3.97 17.5-7.7s20.53-7.93 26.6-12.6 11.9-13.3 17.5-25.9c5.6-12.6 9.57-19.83 11.9-21.7 2.33-1.87 4.43-5.37 6.3-10.5s2.8-10.27 2.8-15.4c0-5.13-3.03-10.5-9.1-16.1-6.07-5.6-9.57-10.5-10.5-14.7-.93-4.2-7-16.8-18.2-37.8-11.2-21-16.8-33.37-16.8-37.1 0-3.73-3.73-11.2-11.2-22.4-7.47-11.2-10.97-22.4-10.5-33.6.47-11.2 0-20.3-1.4-27.3s-1.4-15.17 0-24.5 1.4-17.03 0-23.1-2.1-12.83-2.1-20.3v-11.2h1.4c.93 0 1.87-1.17 2.8-3.5.93-2.33.7-4.2-.7-5.6-1.4-1.4-2.1-3.03-2.1-4.9 0-1.87.7-3.03 2.1-3.5 1.4-.47 2.1-2.1 2.1-4.9 0-2.8-.47-5.37-1.4-7.7-.93-2.33-2.33-3.97-4.2-4.9-1.87-.93-2.8-2.33-2.8-4.2s-1.4-3.03-4.2-3.5c-2.8-.47-5.13-2.567-7-6.3-1.87-3.733-2.8-6.3-2.8-7.7 0-1.4.7-2.567 2.1-3.5 1.4-.933 2.1-3.033 2.1-6.3s-1.4-6.3-4.2-9.1c-2.8-2.8-3.03-5.6-.7-8.4 1.17-1.4 2.33-2.8 3.5-4.2l-2.8-.7c-1.87-.467-3.97 1.167-6.3 4.9-2.33 3.733-4.2 5.833-5.6 6.3l-2.1.7v-4.2c0-2.8-.7-5.133-2.1-7-1.4-1.867-3.5-3.033-6.3-3.5l-4.2-.7c.23.933.47 1.867.7 2.8.23.933.47 1.867.7 2.8-.93-.467-1.87-.933-2.8-1.4-1.87-.933-3.03-3.5-3.5-7.7-.47-4.2-1.63-7-3.5-8.4-1.87-1.4-2.8-2.8-2.8-4.2v-2.1c-.47.7-.93 1.4-1.4 2.1-.47.7-.93 1.4-1.4 2.1-.93-2.333-1.87-4.667-2.8-7-1.87-4.667-5.6-9.8-11.2-15.4s-8.63-10.033-9.1-13.3c-.47-3.267-1.87-6.067-4.2-8.4s-3.73-5.133-4.2-8.4c-.47-3.267-1.87-6.067-4.2-8.4s-5.37-7.933-9.1-16.8c-3.73-8.867-10.03-18.9-18.9-30.1-8.87-11.2-16.33-18.9-22.4-23.1-6.07-4.2-11.2-7-15.4-8.4-4.2-1.4-13.3-2.333-27.3-2.8-14-.467-26.37 2.1-37.1 7.7z"
          opacity="1"
        ></path>
        <path
          strokeWidth="3"
          d="M1674.47 1395.02s7.79-27.86 38.51-38.6c36.46-12.73 60.31 26.4 60.31 26.4l-23.92-45.4"
          opacity="1"
        ></path>
        <path
          strokeWidth="5"
          d="M1667.25 1386.42s10.63 12.75 20.68 26.08c7.95 10.54 13.32 21.5 28.25 26.43 15.56 5.15 36.29-.36 52.83-3.2 19.39-3.33 18.84-8.99 33.47-4.59 14.62 4.39 23.82 20.64 23.82 20.64s-.18 3.88.81 8.49 1.88 6.91 3.94 10.98c2.06 4.06 2.34.24 5.54 4.18 1.69 2.09 1.94 5.05 3.85 8.07 1.92 3.03 3.81 4.03 3.81 4.03l17.53 24.15 1.5 9.76s21.78 16.89 34.29 16.42c7.96-.3 2.68-1.51 14.96-7.29 3.32-1.56 7.51 1.73 12.35-1.56 1.6-1.09-.8-4.41.96-5.7 2.3-1.68 5.09-1.73 9.82-2.99 1.27-.34 5.89-5.94 11.65-10.66 2.52-2.06 8.95-2.64 11.82-4.99 1.98-1.61 2.26-4.19 4.18-5.9 2.51-2.23 9.31-1.51 11.71-3.66 2.45-2.2 2.61-6.3 4.34-8.51 5.08-6.51 9.06-10.42 9.06-10.42"
          opacity="1"
        ></path>
        <path
          strokeWidth="5"
          d="M1664.11 1509.68s61.15 34.49 122.87 66.56c13.69 7.11 24.33 17.44 37.8 23.49 20.66 9.27 30.55 30.54 49.29 31.5 20.53 1.06 29.95-16.71 46.04-25.49 13.69-7.46 24.32-19.26 37.92-24.7 2.18-.87 1.77-7.45 3.47-8.92 2.37-2.06 5.6 1.81 7.84-.19 4.23-3.77 4.7-13.57 8.34-17.31 1.41-1.45 7.44.86 8.8-.49 4.49-4.44.96-17.76 6.04-16.65 17.37 3.79 15.87-10.16 15.87-10.16"
          opacity="1"
        ></path>
        <path
          strokeWidth="5"
          d="M1823.93 1447.33l40.89 20.45"
          opacity="1"
        ></path>
        <path
          strokeWidth="5"
          d="M1844.93 1486.02s38.21-45.91 77.73-26.96c25.44 12.2 34 42.91 34 42.91"
          opacity="1"
        ></path>
        <path
          strokeWidth="3"
          d="M1781.59 1349.17l2.68 44.79"
          opacity="1"
        ></path>
        <path
          strokeWidth="5"
          d="M1579.93 1638.04s11.78-1.29 25.54 5.52c9.77 4.82 19.49 17.23 31.35 21.39 28.59 10.02 39.28 15.32 57.44 13.17.28-.04 1.32-3.57 3.5-8.04 1.55-3.16 1.62-4.77 11.53-14.93 23.91-24.53 80.59-75.14 80.59-75.14"
          opacity="1"
        ></path>
        <path
          strokeWidth="5"
          d="M1864.51 1629.28l-6.73 21.79"
          opacity="1"
        ></path>
        <path
          strokeWidth="5"
          d="M1884.5 1707.75s25.35 6.21 40.84 1.79c15.49-4.42 23.07-20.03 23.07-20.03l2.43 16.43s-7.67 15.68-23.25 20.9c-15.57 5.23-39.05 0-39.05 0"
          opacity="1"
        ></path>
        <path
          strokeWidth="5"
          d="M1945.71 1650.46l2.64 38.15"
          opacity="1"
        ></path>
        <path
          strokeWidth="5"
          d="M1948.83 1668.69l52.43 64.31"
          opacity="1"
        ></path>
        <path
          strokeWidth="5"
          d="M2054.41 1696.29s-14.21 7.45-27.77 17.2c-13.56 9.75-26.46 21.79-26.46 21.79s.85 5.24 4.06 9.07c3.21 3.84 8.78 6.29 8.78 6.29s14.14-11.61 27.01-20.25c12.86-8.64 24.46-14.3 24.46-14.3"
          opacity="1"
        ></path>
        <path
          strokeWidth="1"
          d="M1638.36 1667.52s2.42 5.4 4.78 16.4c1.03 4.77-.76 11.77 1.91 17.89 4.3 9.87 10.05 23.79 16 32.81 6.24 9.47 12.58 13.8 12.58 13.8s14.4-3.45 31.08-13.11c46.24-26.78 127.56-130.13 127.56-130.13"
          opacity="1"
        ></path>
        <path
          strokeWidth="1"
          d="M1851.37 1492.63s16.94-13.64 35.8-6.84c4.54 1.64 9.02 5 14.21 8.26 5.2 3.28 11.11 6.46 14.53 9.98 7.34 7.54 10.88 15.79 10.88 15.79"
          opacity="1"
        ></path>
        <path strokeWidth="1" d="M1920.28 1607.92l-.32 7.42" opacity="1"></path>
        <path
          strokeWidth="1"
          d="M1922.61 1661.71s-1.05 7.16 1.57 17.61 8.91 24.2 8.91 24.2"
          opacity="1"
        ></path>
        <path strokeWidth="1" d="M1970.79 1628.6l54.74 83" opacity="1"></path>
        <path
          strokeWidth="5"
          d="M1975.49 1565.56s7.16 7.11 9.2 17.27c2.04 10.16-1.05 23.36-1.05 23.36s7.62-11.35 13.54-18.14c3.38-3.87 5.2-2.23 7.25-6.3"
          opacity="1"
        ></path>
        <path
          strokeWidth="1"
          d="M1951.52 1695.77s4.46-.24 8.45 1.75c2.81 1.4 6.43 6.25 9 7.26 6.22 2.43 7.4.72 7.4.72"
          opacity="1"
        ></path>
        <path
          strokeWidth="1"
          d="M1889.75 1733.9s19.99 19.62 39.26 16.45c7.56-1.25 14.66-14.74 20.93-20.06 9.69-8.23 16.88-9.07 16.88-9.07"
          opacity="1"
        ></path>
        <path
          strokeWidth="1"
          d="M1880.42 1764.99s10.36 7.03 43.48 7.31c33.11.28 88.99-6.18 88.99-6.18"
          opacity="1"
        ></path>
        <path
          strokeWidth="1"
          d="M1952.53 1702.75l14.85 12.02"
          opacity="1"
        ></path>
        <path
          strokeWidth="1"
          d="M1952.5 1705.63s2.02 5.44 1.31 11.1c-.7 5.66-3.15 12.39-3.15 12.39"
          opacity="1"
        ></path>
        <path
          strokeWidth="5"
          d="M2015.26 1749.59c1.88 2.51 3.53 3.11 4.76 5.84s.44 7.59.44 7.59-4.29 1.98-6.84 6.32-5.1 14.43-5.1 14.43"
          opacity="1"
        ></path>
        <path
          strokeWidth="1"
          d="M2020.61 1765.82s8.96 11.15 24.37 10.23c15.4-.92 21.38-10.69 33.88-13.68 12.5-3 17.73 1.05 17.73 1.05"
          opacity="1"
        ></path>
        <path
          strokeWidth="1"
          d="M2082.32 1745.27s-5.84 4.71-8.3 9.46c-2.47 4.75-1.57 9.53-1.57 9.53"
          opacity="1"
        ></path>
        <path
          strokeWidth="1"
          d="M2007.67 1800.1c.39-.23 12.94 4.63 31.85 8.08 6.75 1.23 12.48.49 20.48 1.32 11.59 1.21 25.88 3.81 37.81 4.69 18.12 1.32 36.52 4.22 50.69 3.72 19.6-.69 31.96-5.19 31.96-5.19"
          opacity="1"
        ></path>
        <path
          strokeWidth="1"
          d="M1773.25 1383.02s4.59 4.12 9.91 11.12c1.66 2.19 3.4 4.66 5.09 7.37 7.09 11.39 14.58 27.34 14.58 27.34"
          opacity="1"
        ></path>
        <path
          strokeWidth="5"
          d="M2182.83 1263.29s16.35-13.35 34.59-4.72c22.56 10.67 21.06 33.04 21.06 33.04l14.05 2.48s2.73-1.36 5.94-4.42c1.5-1.44 2.66-3.57 4.49-5.52 2.26-2.41 4.48-8.21 7.17-9.82 3.07-1.85 3.7-1.88 5.46-4.78 4.2-6.98 1.11-10.93 5-18.99 3.89-8.05 4.98-8.23 10.51-14.12 2.94-3.13 6.85-5.26 8.65-10.36 4.18-11.8 6.06-36.36 6.06-36.36s2.64-.29 4.66 4.62c1.52 3.7 2.33 10.74 3.42 20.92 2.55 23.68 1.34 68.99 1.34 68.99"
          opacity="1"
        ></path>
        <path
          strokeWidth="5"
          d="M2238.74 1292.56s7.34 3.67 23.62 4.26c16.28.59 40.16-.24 40.16-.24"
          opacity="1"
        ></path>
        <path
          strokeWidth="5"
          d="M2603.98 1339.83c-9.32-.36-6.98-8.93-19.49-17.21-12.07-7.99-29.44-15.16-42.61-24.47-7.47-5.28-10.81-14.89-16.76-18.01-8.79-4.61-7.89 0-14.73 2.34-5.61 1.91-4.79 1.95-15.71.04-10.12-1.77-30.93-5.86-46.52-4.29-9.92.99-14.2 8.01-23.65 7.33-7.55-.55-6.94-3.64-13.71-4.79-5.18-.88-12.38 1.62-17.41.73-4.69-.82-12.5-2.55-16.48-3.6-12.37-3.28-11.14 2.96-17.21-6.27-3.49-5.29-5.74-22.2-7.97-31.58-.9-3.76 1.16-8.94.42-12.62-1.05-5.23-5.88-12.73-6.88-17.29-3.23-14.66-2.14-22.45-2.14-22.45s12.45-11.9 27.68-20.81c15.24-8.92 33.26-14.86 33.26-14.86s2.5.87 9.79 15.8c7.29 14.93 19.36 43.92 19.36 43.92"
          opacity="1"
        ></path>
        <path
          strokeWidth="1"
          d="M2349.66 1178.96s-2.49-40.03-2.29-62.72c.21-22.7 1.97-31.81 1.97-31.81"
          opacity="1"
        ></path>
        <path
          strokeWidth="1"
          d="M2402.15 1150.9s-7.18-22.77-11.48-40c-4.3-17.24-5.72-28.93-5.72-28.93"
          opacity="1"
        ></path>
        <path
          strokeWidth="3"
          d="M2357.72 1274.3s-48.37-6.5-65.51 42.43c-17.14 48.92-3.78 157.99-3.78 157.99"
          opacity="1"
        ></path>
        <path strokeWidth="1" d="M2238.3 1323.9l47.14 16.96" opacity="1"></path>
        <path
          strokeWidth="3"
          d="M2381.36 1469.41s6.17-46.38 4.62-76.09c-1.55-29.72-8.38-47.51-8.38-47.51"
          opacity="1"
        ></path>
        <path
          strokeWidth="3"
          d="M2387.27 1395.59s23.18 9.05 44.78 15.31 45.85 6.47 45.85 6.47"
          opacity="1"
        ></path>
        <path
          strokeWidth="5"
          d="M2538.79 1410.69c-9.14-7.49-19.66-27.02-26.37-25.24-14.98 3.97-41.21 36.88-41.21 36.88s16.21 3.55 22.01 16.56c5.8 13.01 1.21 35.48 1.21 35.48"
          opacity="1"
        ></path>
        <path
          strokeWidth="5"
          d="M2435.14 1412.91s-12.41 9.77-21.89 23.21c-9.48 13.43-16.02 30.53-16.02 30.53"
          opacity="1"
        ></path>
        <path
          strokeWidth="3"
          d="M2207.05 1420.24s-1.42-11.6-1.73-24.92c-.23-9.51 1.04-19.71-.45-28.03-3.57-19.97-10.97-27.7-10.97-27.7"
          opacity="1"
        ></path>
        <path
          strokeWidth="5"
          d="M2298.03 1615.88s15.17 5.39 29.15 5.5c13.98.11 26.78-5.05 26.78-5.05"
          opacity="1"
        ></path>
        <path
          strokeWidth="1"
          d="M2297.56 1593.89s12.05 8.72 27.76 8.63c15.71-.1 35.07-9.01 35.07-9.01"
          opacity="1"
        ></path>
        <path
          strokeWidth="1"
          d="M2383.04 1463.08s3.83-17.19 12.88-30.74c9.06-13.55 23.88-23.39 23.88-23.39"
          opacity="1"
        ></path>
        <path
          strokeWidth="5"
          d="M2350.48 1655.58s1.79 25.1-16.93 40.47c-12.48 10.23-40.07-5-40.07-5"
          opacity="1"
        ></path>
        <path
          strokeWidth="1"
          d="M2495.11 1399.75s32.63 26.39 56.68 55.38c24.05 29 39.52 60.6 39.52 60.6"
          opacity="1"
        ></path>
        <path
          strokeWidth="1"
          d="M2499.61 1394.54s33.61 28.26 57.66 57.25c24.05 29 40.6 66.83 40.6 66.83"
          opacity="1"
        ></path>
        <path
          strokeWidth="1"
          d="M2364.04 1691.95s-11 16.52-24.65 40.8c-6.7 11.92-9.92 33.18-20.81 40.73-14.74 10.24-35.36 15.71-51.72 16.05-20.32.43-35.02-5.78-35.02-5.78"
          opacity="1"
        ></path>
        <path
          strokeWidth="5"
          d="M2297.82 1112.65c2.21 40.29-1.41 57.18 8.56 77.01"
          opacity="1"
        ></path>
      </g>
    </svg>
  );
}

export default Icon;